
import React from "react";
import OneOnOneView from "../components/One_on_one";
import { SalesPageToolSet } from "./SalesPageToolSet";


const OneOnOneContainer = (props) => {

    const [tool,setTool] = React.useState({});

    

    React.useEffect(()=>{
        if(props.match.params.id){
            let filteredTool =  SalesPageToolSet.find(value=>value.id === parseInt(props.match.params.id))
            setTool(filteredTool)
        }

    },[props.match.params.id])


    return (
        <>
            <OneOnOneView tool = {tool} />
        </>
    );
};

export default OneOnOneContainer;

